import { render } from "./TotalsSection.vue?vue&type=template&id=41c35b68&scoped=true"
import script from "./TotalsSection.vue?vue&type=script&lang=js"
export * from "./TotalsSection.vue?vue&type=script&lang=js"

import "./TotalsSection.vue?vue&type=style&index=0&id=41c35b68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c35b68"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QAvatar,QList,QItemLabel,QBadge});
